import { combineReducers } from "redux";

import FaqReducer from "@tCentro/Store/Components/Faq/FaqReducer";
import NewsListFilterReducer from "@tCentro/Store/Components/NewsListFilter/NewsListFilterReducer";
import CENAddressValidationReducer from "@tCentro/Store/Reducer/CENAddressValidationReducer";
import CENBlogSearchQueryReducer from "@tCentro/Store/Reducer/CENBlogSearchQueryReducer";
import CENContentTabFilterReducer from "@tCentro/Store/Reducer/CENContentTabFilterReducer";
import CenIsGuestIsItemOverweightReducerStore from "@tCentro/Store/Reducer/CenIsGuestIsItemOverweightReducerStore";
import CenQtyMinReducerStore from "@tCentro/Store/Reducer/CenQtyMinReducerStore";
import CENQtyMultiCheckoutErrReducerStore from "@tCentro/Store/Reducer/CENQtyMultiCheckoutErrReducerStore";
import CenQtyMultiReducerStore from "@tCentro/Store/Reducer/CenQtyMultiReducerStore";
import CENSearchBlogResultReducer from "@tCentro/Store/Reducer/CENSearchBlogResultReducer";
import CenSelectedArticleTypeReducer from "@tCentro/Store/Reducer/CenSelectedArticleTypeReducer";
import CenShippingFieldCompletedReducerStore from "@tCentro/Store/Reducer/CenShippingFieldCompletedReducerStore";
import CenOrderDetailsFieldCompletedReducerStore from "@tCentro/Store/Reducer/CenOrderDetailsFieldCompletedReducerStore";
import CenDeliveryFieldCompletedReducerStore from "@tCentro/Store/Reducer/CenDeliveryFieldCompletedReducerStore";
import CenSpcOrderNotesDisableReducerStore from "@tCentro/Store/Reducer/CenSpcOrderNotesDisableReducerStore";
import CENSPCOrderNotesReducer from "@tCentro/Store/Reducer/CENSPCOrderNotesReducer";
import CENSPCPONumberReducer from "@tCentro/Store/Reducer/CENSPCPONumberReducer";
import CenSpcShippingDisableReducerStore from "@tCentro/Store/Reducer/CenSpcShippingDisableReducerStore";
import CustomAttributeNamesReducer from "@tCentro/Store/Reducer/CustomAttributeNamesReducer";
import CustomAttributeSearchTermReducer from "@tCentro/Store/Reducer/CustomAttributeSearchTermReducer";
import CustomOnePageCheckoutReducer from "@tCentro/Store/Reducer/CustomOnePageCheckoutReducer";
import CustomPDPOverViewBlockReducer from "@tCentro/Store/Reducer/CustomPDPOverViewBlockReducer";
import CustomShipViaAccountNumberReducer from "@tCentro/Store/Reducer/CustomShipViaAccountNumberReducer";
import CustomVariantAddToCartReducer from "@tCentro/Store/Reducer/CustomVariantAddToCartReducer";
import CustomBrandDataReducer from "@tCentro/Store/Reducer/CustomBrandDataReducer";
import CustomHomepageBrandReducer from "@tCentro/Store/Reducer/CustomHomepageBrandReducer";
import CENCustomCategoriesFilterPropertiesReducer from "@tCentro/Store/Reducer/CENCustomCategoriesFilterPropertiesReducer";
import CENShppingAddressTypeReducerStore from "@tCentro/Store/Reducer/CENShippingAddressTypeReducerStore";
import EnableplaceordershippinghandlingReducerStore from "@tCentro/Store/Reducer/EnablePlaceOrderShippingHandlingReducerStore";
import CatFaqReducer from "@tCentro/Store/Reducer/CatFaqReducer";
import CENProductFamiliesReducer from "@tCentro/Store/Reducer/CENProductFamiliesReducer";

const componentsReducers = {
    newsListFilter: NewsListFilterReducer,
    faq: FaqReducer,
    catFaq:CatFaqReducer,
    collectAccountNumber: CustomShipViaAccountNumberReducer,
    overViewPdpBlock: CustomPDPOverViewBlockReducer,
    attributeSearchText: CustomAttributeSearchTermReducer,
    attributeNames: CustomAttributeNamesReducer,
    cenVariantPdpAddToCartIsClicked: CustomVariantAddToCartReducer,
    onePageCheckoutOnetimeAddress: CustomOnePageCheckoutReducer,
    OrderNotes: CENSPCOrderNotesReducer,
    SpcPONumber: CENSPCPONumberReducer,
    isShippingStateDisabled: CenSpcShippingDisableReducerStore,
    isOrderNotesDisabled: CenSpcOrderNotesDisableReducerStore,
    isMinError: CenQtyMinReducerStore,
    isMultiError: CenQtyMultiReducerStore,
    isSaveOrderShippingEnabled: EnableplaceordershippinghandlingReducerStore,
    isMinOrMultiError: CENQtyMultiCheckoutErrReducerStore,
    isGuestandIsOverweight: CenIsGuestIsItemOverweightReducerStore,
    isShippingFieldCompleted: CenShippingFieldCompletedReducerStore,
    isOrderDetailsFieldCompleted: CenOrderDetailsFieldCompletedReducerStore,
    isDeliveryFieldCompleted: CenDeliveryFieldCompletedReducerStore,
    selectedArticleType: CenSelectedArticleTypeReducer,
    selectedContentType: CENContentTabFilterReducer,
    searchQuery: CENBlogSearchQueryReducer,
    storeBlogResult: CENSearchBlogResultReducer,
    isErrorOccured: CENAddressValidationReducer,
    CustomBrandData: CustomBrandDataReducer,
    CustomHomepageBrandFiltersData: CustomHomepageBrandReducer,
    CENCustomCategoriesFilterPropertiesData: CENCustomCategoriesFilterPropertiesReducer,
    CENShppingAddressTypeData: CENShppingAddressTypeReducerStore,
    CENProductFamiliesData: CENProductFamiliesReducer,
};

export type ComponentsReducers = typeof componentsReducers;

const componentsReducer = combineReducers(componentsReducers as any);

export default componentsReducer;
